module.exports = __webpack_public_path__ + "f4440cb8.svg";